<template>
<!--
    Author:lan.huang
    time:2020-02-20
    content:科研战“疫”
 -->
<div >
    <div v-if="theme_switch" class="data-tip">
        <i class="iconfont">&#xe654;</i>
        <span>{{top_tip_text}}</span>
    </div>
    <div v-if="theme_switch" class="index_content" style="margin-top:17px">
        <div class="real-content">
            <div class="real-time-dynamic">
                <img class="real-img" :src="$store.state.static_img_url+'pic/scientific/real_time_logo2x.png'" />
                <swiper
                    :options="swiperOption"
                    ref="mySwiper"
                    v-if="new_topic && new_topic.length > 0"
                >
                    <swiper-slide v-for="(item,index) in new_topic" :key="index">
                        <span class="real-time">{{item.create_time | time_standard}}</span>
                        <span class="real-type">新型冠状病毒</span>
                        <p class="real-title" @click="goDetail(item.uid)">{{item.title}}</p>
                        <span class="real-go" @click="goDetail(item.uid)">查看详情<i class="real-go-i iconfont">&#xe647;</i></span>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="looking-enterprise" @click="goCompanyList()">
                找企业
                <img :src="$store.state.static_img_url+'pic/scientific/find-qiye.png'">
            </div>
            <div class="solicitation-case" @click="modelIndex=true">征集案例<img :src="$store.state.static_img_url+'pic/scientific/fing-ziyuan.png'"></div>
        </div>
        <!-- 内容 -->
        <div class="main-content"  v-for="(item, index) in contentList" :key="index">
            <div class="first-header">
                <div class="number">{{item.sort_name}}</div>
                <div class="first-title">{{item.name}}</div>
                <div class="first-tip">{{item.product_num}}大类产品，{{item.company_num}}家企业</div>
                <div class="first-percent"><i>{{item.p_num}}</i>/{{item.children.length}}</div>
            </div>
            <div class="wrapper">
                <div class="left" v-if="item.temp < 0"  @click="leftmove(index)">
                    <img :src="$store.state.static_img_url+'pic/scientific/arrowleft@2x.png'" />
                </div>
                <ul  class="theme-content"  :style="{width: item.children.length * 300+16*(item.children.length-1) + 'px','margin-left': item.temp * 300+item.temp*16 + 'px'}">
                    <li v-for="(child , index1) in item.children" :key="index1" @click="goThemeDetail(child.uid, 'theme')" >
                        <div class="header-logo"><img  :src="'https://cdn.vcbeat.top/upload/dynview_miniprogram'+child.header_logo" /></div>
                        <div class="header-name">{{child.name}}</div>
                        <div class="header-tip">
                            <span class="header-tip-num">{{child.company_num}}</span><span>家企业</span>
                            <!-- <span class="header-tip-num2">{{child.d_num}}</span><span>大类产品</span> -->
                        </div>
                        <div class="map-content">
                            <div v-if="child.logoList.length <3" class="map-content-b" >
                                <div class="map-img" v-for="(logo, index3) in child.logoList" :key="index3">
                                    <Tooltip :content="logo.name" placement="top-start" :transfer="true">
                                        <img v-on:click.stop="goThemeDetail(logo.uid, 'logo')" :src="logo.logo_url" />
                                    </Tooltip>
                                </div>
                            </div>
                            <div v-else class="map-content-b2" >
                                <div class="map-img" v-for="(logo, index3) in child.logoList" :key="index3" v-if="index3<9">
                                    <Tooltip :content="logo.name" placement="top-start" :transfer="true">
                                        <img v-on:click.stop="goThemeDetail(logo.uid, 'logo')" :src="logo.logo_url" />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="topic-list">
                            <div class="topic-p" v-for="(topic, index2) in child.msgList" :key="index2" >
                                <div v-if="index2<3 && topic.title" class="topic-time">{{topic.publish_time | time_standard_day}}</div>
                                <p v-if="index2<3 && topic.title" class="topic-name" >{{topic.title}}</p>
                            </div>
                        </div>
                        <img class="marker" v-if="child.is_marker" :src="$store.state.static_img_url+ 'pic/scientific/marker.png'">
                    </li>
                </ul>
                <div class="right" v-if="item.temp > -(item.children.length -3) && item.children.length>3" @click="rightmove(index)">
                    <img :src="$store.state.static_img_url+'pic/scientific/arrowright@2x.png'" />
                </div>
            </div>

        </div>
        <Spin fix v-if="loading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
    <!-- 弹窗 -->
    <Modal v-if="theme_switch" v-model="modelIndex"  :closable="false"  width="500"  class="cbModel">
        <div slot="header">
            <i class="iconfont" @click="modelIndex = false">&#xe65e;</i>
        </div>
        <img class="popup-img" :src="$store.state.static_img_url+'pic/scientific/popup.png'" />
    </Modal>
    <!-- 深色版 -->
    <div class="black" v-if="!theme_switch">
        <div>
            <img :src="$store.state.static_img_url+'pic/scientific/black.png'" />
            <p class="black-tip">深色版暂不支持浏览</p>
        </div>
    </div>
</div>
</template>

<script>
import {dgxcxKjzy, topicList, dgxcxkjzynew} from '@/service'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    components: {
    },
    data() {
        return {
        top_tip_text:'', //顶部说明
        contentList:[],
        new_topic:[],
        swiperOption: {
            autoplay: true,
            speed: 300,
            direction: 'vertical',
            loop: true,
            observer: true,  //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,  //修改swiper的父元素时，自动初始化swiper
        },
        temp:0,
        modelIndex: false,
        loading:true
        }
    },
    methods: {
        async getThemeList() {
            let res = await dgxcxkjzynew( (error) => {
                this.$Message.error('请求错误！')
            })
            if(res.status == '1') {
                this.top_tip_text = res.top_tip_text
                this.$set(this.$data, 'contentList', res.contentList)
                for(let item of this.contentList){
                    item.temp = 0
                    if(item.children.length>2){
                        item.p_num = 3
                    }
                    else{
                        item.p_num = item.children.length
                    }
                    if(item.children.length>0){
                        for(let i of item.children){
                            if(i.logoList.length>0){
                                let a = i.logoList.filter((j, i) => {
                                    return j.logo_url != ""
                                })
                                i.logoList =  a
                            }
                        }
                    }
                }
                this.loading = false
            } else {
                this.$Message.error(res.message)
            }
        },
        async getTopicList() {
            let res = await topicList({type: [70]}, (error) => {
                this.$Message.error('请求错误！')
            })
            if(res.status == 'success') {
                this.$set(this.$data, 'new_topic', res.res)
            } else {
                this.$Message.error(res.message)
            }
        },
        goDetail(uid) { //快讯查看详情
            const href = this.$store.state.index2_path + '/newsDetail/' + uid
            window.open(href, '_blank')
        },
        goCompanyList(){ //找企业
            this.$router.push({ name: 'CompanyList'})
        },
        goThemeDetail(uid, which){//跳转到专题详情
            if(which == 'logo'){
                if(uid){
                    window.open(this.$store.state.req_url+'/companyDetail/'+ uid , '_blank')
                }
            }
            else{
                if(uid){
                    const { href } = this.$router.resolve({name: "SpecialDetail",params: {uid: uid}})
                    window.open(href, '_blank')
                }
            }
        },
        leftmove(index){
            if (this.contentList[index].temp < 0) {
                this.contentList[index].temp += 1
                this.contentList[index].p_num -=1
                this.$set(this.$data.contentList, index, this.contentList[index])
            }
        },
        rightmove(index){
            // window.scrollTo(300)
            if (this.contentList[index].temp > - (this.contentList[index].children.length -3)) {
                this.contentList[index].temp -= 1
                this.contentList[index].p_num +=1
                this.$set(this.$data.contentList, index, this.contentList[index])
            }
        }
    },
    created() {
        this.getTopicList()
        this.getThemeList()
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
        theme_switch() {
            return this.$store.state.theme_switch
        }
    },
    components: {
        swiper,
        swiperSlide,
    }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.data-tip
    height:44px
    width:100%
    background:#FFFAF5
    font-size:14px
    text-align:center;
    color:rgba(102,102,102,1)
    padding: 10px 0
    display:flex
    justify-content: center
    align-items: center
    i
        color: #FC9C7C
        font-size: 20px
        line-height: 20px
        margin-right: 12px
    span
        line-height: 18px
.real-content
    display: flex
    font-size:14px
    .real-time-dynamic
        background:#ffffff
        height:56px
        width:1001px
        padding:21px 20px 18px 30px
        position relative
        display :flex
        .real-img
            width:70px
        .swiper-container
            width: 100%
            height: 18px
            .swiper-wrapper
                .swiper-slide
                    display :flex
                    .real-time
                        color:rgba(121,123,131,1)
                        line-height:20px
                        margin-left:20px
                    .real-type
                        width:84px
                        margin-left:8px
                        color:rgba(250, 122, 80, 1)
                        line-height:20px
                        position: relative
                        &:before
                            position: absolute
                            content: ''
                            height: 16px
                            width: 1px
                            background:#E9E9E9
                            right: -11px
                            top: 1px
                    .real-title
                        margin-left:20px
                        color:rgba(51,51,51,1)
                        line-height:20px
                        cursor :pointer
                        max-width: 600px
                        ellipsis()
                        &:hover
                            color: rgba(250, 122, 80, 1)
                    .real-go
                        position:absolute
                        right:10px
                        color:rgba(250, 122, 80, 1)
                        line-height:17px
                        font-size:12px
                        cursor :pointer
                        &:hover
                            color: rgba(250, 122, 80, 1)
                        .real-go-i
                            margin-left:3px
                            font-size:12px;
    .looking-enterprise
        width:84px
        height:56px
        margin-left:16px
        background:rgba(77,208,225,1)
        color:rgba(255,255,255,1)
        line-height:20px
        text-align :center
        padding:19px 0 19px 0
        cursor :pointer
        position:relative
        img
            position:absolute
            bottom:0
            right:0
            max-width:42px
    .solicitation-case
        width:84px
        height:56px
        background:rgba(159,168,218,1);
        margin-left:12px
        color:rgba(255,255,255,1)
        line-height:20px
        text-align :center
        padding:19px 0 19px 0
        cursor :pointer
        position:relative
        img
            position:absolute
            bottom:2px
            right:0
            max-height:36px
.main-content
    width:1200px
    background:rgba(255,255,255,1)
    margin-top:16px
    padding:30px 30px 29px 29px
    font-size:14px
    font-weight:400
    &:last-child
        margin-bottom 43px
    .first-header
        display: flex
        position relative
        .number
            width:26px
            height:26px
            background: #FF8936
            font-size :16px
            font-weight:600
            color:rgba(255,255,255,1)
            line-height:22px
            text-align:center
            padding:2px 0
        .first-title
            height:33px
            font-size:24px
            font-weight:600
            color:rgba(51,51,51,1)
            margin-left:10px
        .first-tip
            font-size:14px
            color:rgba(153,153,153,1)
            height:20px
            margin-top:8px
            margin-left:9px
            line-height:20px
        .first-percent
            color:rgba(153,153,153,1)
            line-height:20px
            position:absolute
            right:0
            margin-top:3px
            i
                color:rgba(250, 122, 80, 1)
    .wrapper
        position :relative
        overflow :hidden
        width:1141px
        height:426px
        .theme-content
            z-index:10
            margin-top:19px
            display:flex
            li
                width:300px
                height:396px
                border:1px solid rgba(233,233,233,1)
                margin-right:16px
                padding:25px 13px 20px 13px
                position:relative
                text-align:center
                cursor:pointer
                &:hover
                    box-shadow:2px 4px 20px 0px rgba(121,133,143,0.2)
                    border:4px solid rgba(250, 122, 80, 1)
                    position :relative
                    bottom:5px
                    padding:25px 10px 20px 10px
                &:last-child
                    margin-right:0
                .header-logo
                    height:50px
                    display: flex
                    justify-content: center
                    align-items: center
                    img
                        max-height:50px
                        max-width:58px
                .header-name
                    font-size:18px
                    font-weight:600
                    color:rgba(51,51,51,1)
                    line-height:25px
                    margin-top:5px
                .header-tip
                    color:rgba(153,153,153,1)
                    line-height:22px
                    margin-top:12px
                    .header-tip-num
                        font-size:16px
                        font-weight:600
                    .header-tip-num2
                        font-size:16px
                        font-weight:600
                        margin-left:9px
                .map-content
                    margin-top:4px
                    height:131px
                    width:100%
                    display: flex
                    justify-content: center
                    align-items: center
                    .map-content-b
                        width:100%
                        display: flex
                        justify-content: center
                        align-items: center
                        flex-wrap:wrap
                        .map-img
                            width:87px
                            height:40px
                            margin-top:5px
                            margin-right:5px
                            display: flex
                            justify-content: center
                            align-items: center
                            .ivu-tooltip
                                display: inline-block
                                vertical-align: top
                                margin:0
                                cursor: pointer
                                >>> .ivu-tooltip-arrow
                                    border-top-color: #404040
                                >>> .ivu-tooltip-inner
                                    max-width: 180px
                                    min-width:160px
                                    white-space: normal
                                    word-break: break-all
                                    background-color: #404040
                            img
                                max-height:40px
                                max-width:87px
                                &:hover
                                    opacity:0.5
                            &:hover
                                box-shadow:2px 4px 20px 0px rgba(121,133,143,0.1)
                            &:nth-child(3n)
                                margin-right:0
                    .map-content-b2
                        width:100%
                        display: flex
                        flex-flow:row wrap
                        align-items:flex-start
                        .map-img
                            width:87px
                            height:40px
                            margin-top:5px
                            margin-right:5px
                            display: flex
                            justify-content: center
                            align-items: center
                            .ivu-tooltip
                                display: inline-block
                                vertical-align: top
                                margin: 0
                                cursor: pointer
                                >>> .ivu-tooltip-arrow
                                    border-top-color: #404040
                                >>> .ivu-tooltip-inner
                                    max-width: 180px
                                    min-width:160px
                                    white-space: normal
                                    word-break: break-all
                                    background-color: #404040
                            img
                                max-height :40px
                                max-width:87px
                                &:hover
                                    opacity:0.5
                            &:hover
                                box-shadow:2px 4px 20px 0px rgba(121,133,143,0.1)
                            &:nth-child(3n)
                                margin-right:0
                .topic-list
                    margin-top:26px
                    text-align:left
                    position: relative
                    .topic-p
                        margin-top:7px
                        display :flex
                        .topic-time
                            font-size:12px
                            color:rgba(254,184,95,1)
                            line-height:18px
                            background:rgba(255,246,231,1)
                            border-radius:4px
                            width:56px
                            text-align :center
                            height:18px
                        .topic-name
                            color:rgba(51,51,51,1)
                            line-height:20px
                            margin-left:8px
                            width:196px
                            white-space:nowrap
                            overflow:hidden
                            text-overflow:ellipsis
                            &:hover
                                color: rgba(250, 122, 80, 1)
                    &:before
                        content: ''
                        position: absolute
                        width: 268px
                        border-top: 1px dashed
                        commonBorderColor(#40444f, #E9E9E9)
                        left: 0
                        top: -10px
                        right:0
                .marker
                    position:absolute
                    right:0
                    top:0
                    max-width:36px
        .right
            z-index:150
            position:absolute
            width:50px
            height:412px
            right:0
            bottom:0
            display: flex
            justify-content: flex-end
            align-items: center
            background:linear-gradient(90deg,rgba(255,255,255,0.7) 0%,rgba(255,255,255,1) 100%)
            img
                cursor :pointer
                width:30px
        .left
            z-index:150
            position:absolute
            width:50px
            height:412px
            left:0
            bottom:0
            display: flex
            justify-content: flex-start
            align-items: center
            background:linear-gradient(90deg,rgba(255,255,255,1) 0%, rgba(255,255,255,0.7) 100%)
            img
                cursor :pointer
                width:30px
&:nth-child(2)
    li
        &:nth-child(5)
            .header-logo
                img
                    margin-left:15px
        &:nth-child(6)
            .header-logo
                img
                    margin-left:17px
.cbModel
  >>> .ivu-form-item-error-tip
    position: inherit
  >>> .ivu-modal
    .ivu-modal-content
        background-color:transparent
        box-shadow:none
        .ivu-modal-header
                border-bottom: 0
                padding: 0
                opacity:0.4
                position: relative
            .iconfont
                position: absolute
                font-size:24px
                color:#fff
                opacity:1
                right: 23px
                top: 5px
                cursor: pointer
                &:hover
                    color:rgba(250, 122, 80, 1)
        .ivu-modal-body
            .popup-img
                width:480px
        .ivu-modal-footer
            display :none
.black
    width:100%
    min-height: 618px
    display: flex
    display: -webkit-flex
    align-items:center
    justify-content:center
    text-align :center
    img
        width:180px
    .black-tip
        font-size:14px
        font-weight:400
        color:rgba(121,123,131,1)
        line-height:20px
        margin-top:13px

</style>
